'use client'
import { useCallback, useMemo, useState } from 'react'

import { trackEvent } from '@mercadoni/sinister/dist/cjs/monitors/services'
import { ModalProperties, ModalPropsByType, ModalTypes } from './entities'

const useModalContextValue = (): ModalProperties => {
  const [isOpenModal, setIsOpenModal] = useState(false)
  const [modalType, setModalType] = useState<ModalTypes | null>(null)
  const [modalProps, setModalProps] = useState<
    ModalPropsByType[ModalTypes] | null
  >(null)

  const openModal = useCallback(
    (type: ModalTypes, props?: ModalPropsByType[ModalTypes]) => {
      setIsOpenModal(true)
      trackEvent({
        eventName: `open_modal_${type}`,
      })
      setModalType(type)
      setModalProps(props || null)
    },
    []
  )

  const closeModal = useCallback(() => {
    setIsOpenModal(false)
    trackEvent({
      eventName: `close_modal_${modalType}`,
    })
    setModalType(null)
    setModalProps(null)
  }, [modalType])

  const value: ModalProperties = useMemo(
    () => ({
      isOpenModal,
      openModal,
      closeModal,
      modalType,
      modalProps,
    }),
    [isOpenModal, openModal, closeModal, modalType, modalProps]
  )

  return value
}

export default useModalContextValue
